module.exports = __webpack_public_path__ + "static/img/store-car-null_dark.5d7c334c.png";